// How often a schedule re-runs, as a radio group matching ModeSelect's shape.
import { SegmentedControl } from '@/components/SegmentedControl'
import {
  SegmentedIndicator,
  segmentedOptionClassName,
} from '@/components/SegmentedIndicator'
import { CADENCES, cadenceLabel } from '@/lib/cadence'
import type { CadenceSelectProps } from './CadenceSelect.types'

export function CadenceSelect({
  name,
  value,
  disabled,
  onChange,
}: CadenceSelectProps) {
  const indicatorId = `${name}-active-indicator`

  return (
    <fieldset>
      <legend className="text-xs uppercase tracking-wider text-muted-foreground">
        Cadence
      </legend>

      <SegmentedControl className="mt-2" label="Cadence">
        {CADENCES.map((cadence) => (
          <label
            key={cadence}
            className={segmentedOptionClassName(value === cadence)}
          >
            {value === cadence && <SegmentedIndicator layoutId={indicatorId} />}
            <input
              type="radio"
              name={name}
              value={cadence}
              checked={value === cadence}
              disabled={disabled}
              onChange={() => onChange(cadence)}
              className="sr-only"
            />
            <span className="relative">{cadenceLabel(cadence)}</span>
          </label>
        ))}
      </SegmentedControl>
    </fieldset>
  )
}
